export default function isNumberOrTrue(value) {
  return !!value || value === 0;
}